
import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar } from 'lucide-react';

interface BillingCycleSelectorProps {
  billingCycle: 'monthly' | 'quarterly' | 'yearly';
  onBillingCycleChange: (cycle: 'monthly' | 'quarterly' | 'yearly') => void;
}

const BillingCycleSelector: React.FC<BillingCycleSelectorProps> = ({
  billingCycle,
  onBillingCycleChange
}) => {
  return (
    <div className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm">
      <div className="flex items-center">
        <div className="p-2 bg-blue-100 rounded-full mr-3">
          <Calendar className="h-5 w-5 text-blue-600" />
        </div>
        <div>
          <h4 className="font-medium">Billing Cycle</h4>
          <p className="text-sm text-muted-foreground">Choose your preferred billing period</p>
        </div>
      </div>
      <div className="flex gap-2">
        {['monthly', 'quarterly', 'yearly'].map((cycle) => (
          <Button
            key={cycle}
            size="sm"
            variant={billingCycle === cycle ? "default" : "outline"}
            onClick={() => onBillingCycleChange(cycle as any)}
            className={billingCycle === cycle ? "bg-blue-600 hover:bg-blue-700" : ""}
          >
            {cycle.charAt(0).toUpperCase() + cycle.slice(1)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default BillingCycleSelector;
